// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"sz-z","smallCardRow":"tz-z","largeCardRow":"uz-z","productSearchRow":"vz-z","curatedRow":"wz-z"};